"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBonusesByType = void 0;
var next_intl_1 = require("next-intl");
var react_1 = require("react");
var currencies_1 = require("../currencies");
var geo_1 = require("../geo");
var keys_1 = require("../keys");
var useCache_1 = require("../useCache");
var useQuery_1 = require("../useQuery");
var user_1 = require("../user");
var CURRENT_CURRENCY = 'current_currency_by_type';
var CURRENT_LANG = 'current_lang';
var CURRENT_TYPE = 'current_bonuses_type';
var CURRENT_AUTH = 'current_auth';
var CURRENT_COUNTRY = 'current_country';
var useBonusesByType = function (bonusType) {
    var _a, _b;
    var isAuth = (0, user_1.useIsAuthorized)();
    var _c = (0, useCache_1.useCache)(), getDataFromCache = _c.getDataFromCache, setDataToCache = _c.setDataToCache;
    var currentCurrency = (0, currencies_1.useCurrentCurrency)();
    var lang = (0, next_intl_1.useLocale)();
    var geoData = (0, geo_1.useGeo)().data;
    var country = (_a = geoData === null || geoData === void 0 ? void 0 : geoData.geoData) === null || _a === void 0 ? void 0 : _a.countryCode;
    var _d = (0, useQuery_1.useQuery)({
        canRender: isAuth,
        path: keys_1.BONUSES_BY_TYPE,
        payload: {
            bonusType: bonusType,
            currency: currentCurrency,
            lang: lang,
            country: country,
        },
        revalidateOnMount: true,
        shouldRetryOnError: false,
    }), data = _d.data, error = _d.error, isLoading = _d.isLoading, mutate = _d.mutate;
    (0, react_1.useEffect)(function () {
        var prevCurrency = getDataFromCache(CURRENT_CURRENCY);
        var prevLang = getDataFromCache(CURRENT_LANG);
        var prevType = getDataFromCache(CURRENT_TYPE);
        var prevAuth = getDataFromCache(CURRENT_AUTH);
        var prevCountry = getDataFromCache(CURRENT_COUNTRY);
        if (!prevCurrency ||
            prevCurrency !== currentCurrency ||
            !prevLang ||
            prevLang !== lang ||
            !prevType ||
            prevType !== bonusType ||
            prevAuth !== isAuth ||
            prevCountry !== country) {
            mutate();
            setDataToCache(CURRENT_CURRENCY, currentCurrency);
            setDataToCache(CURRENT_LANG, lang);
            setDataToCache(CURRENT_TYPE, bonusType);
            setDataToCache(CURRENT_AUTH, isAuth);
            setDataToCache(CURRENT_COUNTRY, country);
        }
    }, [
        lang,
        getDataFromCache,
        setDataToCache,
        currentCurrency,
        mutate,
        bonusType,
        isAuth,
        country,
    ]);
    return (0, react_1.useMemo)(function () { return ({
        data: (data === null || data === void 0 ? void 0 : data.data) || [],
        isLoading: isLoading,
        error: error,
    }); }, [data, isLoading, error, (_b = geoData === null || geoData === void 0 ? void 0 : geoData.geoData) === null || _b === void 0 ? void 0 : _b.countryCode]);
};
exports.useBonusesByType = useBonusesByType;
